(function () {

class $5d2cf9394863bd7b$export$2e2bcd8739ae039 {
    constructor(parent, id, setupData){
        this.e = null // The DOM element representing this component on the HTML page.
        ;
        this.id = id // An identifier, a string which gives access to the component.
        ;
        this.group = null // A group identifier, a string which can be used to find elements by group.
        ;
        this.tag = null // A tag, for custom use.
        ;
        this.parent = parent // The parent component, can be null if this is a root component.
        ;
        this.childs = [] // Array with the childs of this component.
        ;
        this.classList = null // Comma separated list of DOM element class names.
        ;
        this.events = null // Events, that should be handled by this component.
        ;
        this.eventMode = "default" // The mode, in which event handlers should be created.
        ;
        this.routeName = null // Name for routing.
        ;
        // Add component to parent.
        if (parent) parent.childs.push(this);
    }
    /**
     * Build the DOM element(s) of a customized component.
     * This method has to be overriden by derived classes.
     */ build() {}
    /**
     * Update component after changes to it.
     * This method has to be overriden by derived classes.
     *
     * This method will be called, when properties has been changed.
     * The component has to reflect the changes in its visual representation.
     */ propertiesChanged() {}
    /**
     * Build the DOM element(s).
     */ buildDOM() {
        // Call the component dependent build function.
        this.build();
        // Add event handlers, only in 'default' mode.
        if (this.eventMode === "default" && this.events !== null) this.events.forEach((event)=>{
            if (typeof event.handler === "function") this.e.addEventListener(event.type, ()=>event.handler(this));
            else if (typeof event.handler === "object") this.e.addEventListener(event.type, ()=>event.handler.handleEvent(this));
        });
        // Build child components.
        this.buildChilds();
    }
    /**
     * Build all descendant components.
     */ buildChilds() {
        this.childs.forEach((child)=>{
            child.buildDOM();
        });
    }
    /**
     * Get property names.
     *
     * @param {array} customPropertyNames - An array with the names of a derived class.
     * @return {array} An array with property names or undefined, if no properties exist.
     */ getPropertyNames(customPropertyNames) {
        const propertyNames = [
            "id",
            "group",
            "tag",
            "classList",
            "events",
            "eventMode",
            "routeName"
        ];
        if (customPropertyNames !== undefined) return propertyNames.concat(customPropertyNames);
        else return propertyNames;
    }
    /**
     * Set component properties by data.
     *
     * @param {array} data - An array with data in the form of name/value pairs.
     */ setProperties(data) {
        let changed = false;
        if (data !== undefined) {
            const propertyNames = this.getPropertyNames();
            if (propertyNames !== undefined) {
                for (const propertyName of this.getPropertyNames())if (data[propertyName] !== undefined) {
                    this[propertyName] = data[propertyName];
                    changed = true;
                }
            }
        }
        if (changed === true) this.propertiesChanged();
    }
    /**
     * Get component by id.
     *
     * @param {string} id - The id of the component to find.
     * @return {Component} The found component or null, if no component has the given id.
     */ getComponentById(id) {
        if (id === this.id) return this;
        for (const child of this.childs){
            const result = child.getComponentById(id);
            if (result !== null) return result;
        }
        return null;
    }
    /**
     * Count all descendant components.
     * Descendants are children, grandchildren, and so on.
     *
     * @return {number} Number of descendants.
     */ countDescendants() {
        let n = 0;
        for (const child of this.childs)n += child.countDescendants() + 1;
        return n;
    }
    /**
     * Handles a message send to the component.
     *
     * @param {string} message - The message to be handled.
     */ handleMessage(message) {}
    /**
     * Create a DOM element with an optional CSS class.
     *
     * @param {string} tag - The HTML tag to be created.
     * @return {object} The DOM element.
     */ createDomElement(tag) {
        return document.createElement(tag);
    }
    /**
     * Add a DOM element with an optional CSS class.
     *
     * @param {string} tag - The HTML tag to be created.
     * @return {object} The DOM element.
     */ addDomElement(tag) {
        this.e = this.createDomElement(tag);
        this.addElementClasslist(this.e, this.classList);
        this.parent.e.appendChild(this.e);
        return this.e;
    }
    /**
     * Retrieve an element from the DOM.
     *
     * @param {string} selector - DOM selector to the element.
     * @return {HTMLElement} The DOM element or null.
     */ getDomElement(selector) {
        return document.querySelector(selector);
    }
    /**
     * Helper method for adding classes to an DOM element.
     *
     * @param {string} classList - One ore more class names separated with spaces.
     */ addElementClasslist(e, classList) {
        if (classList !== undefined && classList !== null) {
            const classNames = classList.split(" ");
            classNames.forEach((className)=>{
                className = className.trim();
                // TODO: Use try catch
                if (className !== "") {
                    if (!e.classList.contains(className)) e.classList.add(className);
                }
            });
        }
    }
}


class $66a0619dcedb518c$export$2e2bcd8739ae039 extends (0, $5d2cf9394863bd7b$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.parent = null;
    }
    /**
     * Build Document from all components, starting from the view.
     *
     * @param {string} selector - DOM selector to the element, where to mount the app.
     */ buildDOM(selector) {
        this.e = this.getDomElement(selector);
        if (this.e !== null) this.buildChilds();
    }
}





class $d426a2a2a60995b4$export$2e2bcd8739ae039 {
    constructor(model, view){
        this.model = model;
        this.view = view;
        this.context = null;
        this.locale = "en-US";
        this.minFractionDigits = 0;
        this.maxFractionDigits = 2;
        this.router = null;
    }
    /**
     * Configurate the behavior of the controller.
     * Derivated controllers can define their own properties by overriding the method propertyNames.
     *
     * @param {object} data - Configuration data as object with key/value pairs.
     */ configurate(data) {
        if (typeof data === "object") {
            for (const propertyName of this.getPropertyNames())if (data[propertyName] !== undefined) this[propertyName] = data[propertyName];
        }
    }
    /**
     * Get property names.
     *
     * @param {array} customPropertyNames - An array with the names of a derived class.
     * @return {array} An array with property names or undefined, if no properties exist.
     */ getPropertyNames(customPropertyNames) {
        const propertyNames = [
            "locale",
            "minFractionDigits",
            "maxFractionDigits"
        ];
        if (customPropertyNames !== undefined) return propertyNames.concat(customPropertyNames);
        else return propertyNames;
    }
    /**
     * Set properties for a single component.
     *
     * @param {int} id - The id of the component to change.
     * @param {object} data - The properties to change.
     */ setProperties(id, data) {
        const component = this.view.getComponentById(id);
        if (typeof component === "object") component.setProperties(data);
    }
    /**
     * Set new controller context.
     *
     * @param {class} context - The new context to be activated.
     */ setContext(context) {
        this.context = context;
    }
    /**
     * Build the DOM elements.
     *
     * @param {string} selector - DOM selector to the element, where to mount the app.
     */ buildView(selector) {
        this.view.buildDOM(selector);
    }
    /**
     * Get a component by id.
     *
     * @param {string} id - Id of component to get.
     */ getComponentById(id) {
        return this.view.getComponentById(id);
    }
    /**
     * Send a message to the current view.
     *
     * @param {any} message - The component is responsible for the interpretation of the message.
     */ sendMessageToView(message) {
        this.view.handleMessage(message);
    }
    /**
     * Send a message to a specific component.
     *
     * @param {string} id - The id of the component, which should receive the message.
     * @param {any} message - The component is responsible for the interpretation of the message.
     */ sendMessageToComponent(id, message) {
        const component = this.view.getComponentById(id);
        if (typeof component === "object") component.handleMessage(message);
    }
    /**
     * Fetch json data from URL.
     *
     * @param {string} url - URL to the data source.
     */ fetchJsonData(url) {
        // Make an API request using fetch or XMLHttpRequest
        fetch(url).then((response)=>response.json()).then((data)=>{
            // Update the model with the fetched data
            // Muss aufgerufen werden, wenn Daten geladen und temporär in einem Object gespeichert werden
            if (this.context !== null) this.context.onDataChanged(data);
            else this.onDataChanged(data);
        }).catch((error)=>{
            console.error("Error fetching data:", error);
        });
    }
    /**
     * Formats a value for display
     *
     * @param {number} value - The value to format.
     * @param {string} locale - An optional locale, i.e. 'us/EN' or 'de/DE'.
     * @param {int} minFractionDigits - An optional value for the minium amount of digits.
     * @param {int} maxFractionDigits - An optional value for the maxium amount of digits.
     */ formatNumber(value, locale, minFractionDigits, maxFractionDigits) {
        if (typeof value === "undefined" || value === null) return undefined;
        else {
            let usedLocale = this.locale;
            if (typeof locale === "string") usedLocale = locale;
            if (minFractionDigits === undefined) minFractionDigits = this.minFractionDigits;
            if (maxFractionDigits === undefined) maxFractionDigits = this.maxFractionDigits;
            return value.toLocaleString(usedLocale, {
                style: "decimal",
                minimumFractionDigits: minFractionDigits,
                maximumFractionDigits: maxFractionDigits
            });
        }
    }
    /**
     * Converts a float to a string with a maximum of fractional digits.
     *
     * @param {number} value - The value to convert.
     * @param {int} maxFractionDigits - An optional value for the maxium amount of decimal digits.
     * @return {string} A string representing the number with specified decimal digits.
     */ static numberToString(value, maxFractionDigits) {
        if (value === undefined || value === null) return "";
        if (maxFractionDigits === undefined) maxFractionDigits = 2;
        return parseFloat(value.toFixed(maxFractionDigits));
    }
}


class $3015b282b063971c$export$2e2bcd8739ae039 extends (0, $d426a2a2a60995b4$export$2e2bcd8739ae039) {
    constructor(model, view){
        super(model, view);
        this.onDistrictChanged = this.onDistrictChanged.bind(this) // TODO: Description! Why is this necessary?
        ;
    }
    initApp(url, id) {
        const data = this.model.getStorage("data");
        const districtId = this.model.getStorage("districtId");
        if (districtId === null) this.model.setDistrictId(id);
        else this.model.setDistrictId(districtId);
        if (data === null) this.fetchJsonData(url);
        else this.onDataChanged(data);
    }
    updateView() {
        this.setProperties("text-distict-details", {
            html: `<h1>Stadtteil: <strong>${this.model.districtName()}</strong></h1>`
        });
        const residentsInDestrict = this.valueByPath([
            "residents"
        ]);
        const residentsTotal = this.model.residentsTotal();
        const percent = residentsInDestrict / residentsTotal * 100 // TODO
        ;
        this.setProperties("residents-in-destrict", {
            value: this.formatNumber(residentsInDestrict)
        });
        this.setProperties("residents-percent-in-destrict", {
            value: this.formatNumber(percent)
        });
        this.setProperties("residents-total", {
            value: this.formatNumber(residentsTotal)
        });
        this.updateViewAgeSection();
        this.updateViewAgeSection2();
        this.updateSectionBirths();
        this.updateSectionAgeRatio();
        this.updateSectionMigrationBackground();
        this.updateSectionWork();
        this.updateSectionHousingBenefit();
        this.updateSectionHousingAssistance();
        this.setProperties("svg", {
            values: this.model.residentsInDistrictsArray()
        });
    }
    updateViewAgeSection() {
        const items = [
            {
                id: "age-view-1",
                path: [
                    "age_groups",
                    "age_to_under_18"
                ]
            },
            {
                id: "age-view-2",
                path: [
                    "age_groups",
                    "age_18_to_under_30"
                ]
            },
            {
                id: "age-view-3",
                path: [
                    "age_groups",
                    "age_30_to_under_45"
                ]
            },
            {
                id: "age-view-4",
                path: [
                    "age_groups",
                    "age_45_to_under_65"
                ]
            },
            {
                id: "age-view-5",
                path: [
                    "age_groups",
                    "age_65_to_under_80"
                ]
            },
            {
                id: "age-view-6",
                path: [
                    "age_groups",
                    "age_80_and_above"
                ]
            },
            {
                id: "age-view-7",
                path: [
                    "age_groups",
                    "age_0_to_under_7"
                ]
            },
            {
                id: "age-view-8",
                path: [
                    "age_groups",
                    "age_60_and_above"
                ]
            }
        ];
        let sum = 0;
        items.forEach((item)=>{
            sum += this.valueByPath(item.path);
        });
        let barOffset = 0;
        items.forEach((item)=>{
            const c = this.getComponentById(item.id);
            if (c !== undefined) {
                const d = this.valueByPath(item.path);
                const percentage = d / sum * 100;
                c.setProperties({
                    value: this.formatNumber(d),
                    percentage: this.formatNumber(percentage),
                    barOffset: barOffset
                });
                barOffset += percentage;
            }
        });
    }
    updateViewAgeSection2() {
        const items = [
            {
                id: "residents-0-18",
                path: [
                    "age_groups",
                    "age_to_under_18"
                ]
            },
            {
                id: "residents-18-65",
                path: [
                    "age_groups",
                    "age_18_to_under_65"
                ]
            },
            {
                id: "residents-65-above",
                path: [
                    "age_groups",
                    "age_65_and_above"
                ]
            }
        ];
        let sum = 0;
        items.forEach((item)=>{
            sum += this.valueByPath(item.path);
        });
        let barOffset = 0;
        items.forEach((item)=>{
            const c = this.getComponentById(item.id);
            if (c !== undefined) {
                const d = this.valueByPath(item.path);
                const percentage = d / sum * 100;
                c.setProperties({
                    value: this.formatNumber(d),
                    percentage: this.formatNumber(percentage),
                    barOffset: barOffset
                });
                barOffset += percentage;
            }
        });
    }
    updateSectionBirths() {
        const births = this.valueByPath([
            "births"
        ]);
        const birthsTotal = this.model.birthsTotal();
        const percent = births / birthsTotal * 100;
        const birthRate = this.valueByPath([
            "birth_rate"
        ]);
        this.setProperties("births", {
            value: this.formatNumber(births)
        });
        this.setProperties("births-percent", {
            value: this.formatNumber(percent)
        });
        this.setProperties("births-total", {
            value: this.formatNumber(birthsTotal)
        });
        this.setProperties("births-rate", {
            value: this.formatNumber(birthRate)
        });
        const c = this.getComponentById("births-chart");
        if (c !== undefined) c.setProperties({
            values: this.model.birthsInDistrictsArray()
        });
    }
    updateSectionAgeRatio() {
        const ageRatio = this.valueByPath([
            "age_ratio"
        ]);
        this.setProperties("age-ratio", {
            value: this.formatNumber(ageRatio)
        });
    }
    updateSectionMigrationBackground() {
        const residents = this.valueByPath([
            "residents"
        ]);
        const german = this.valueByPath([
            "migration_background",
            "german_citizenship"
        ]);
        const foreign = this.valueByPath([
            "migration_background",
            "foreign_citizenship"
        ]);
        const total = german + foreign;
        const percent = total / residents * 100;
        const germanPercent = german / total * 100;
        const foreignPercent = foreign / total * 100;
        this.setProperties("residents-migration-background", {
            value: this.formatNumber(total)
        });
        this.setProperties("residents-migration-background-percent", {
            value: this.formatNumber(percent)
        });
        let barOffset = 0;
        this.setProperties("german-citizenship", {
            value: this.formatNumber(german),
            percentage: this.formatNumber(germanPercent),
            barOffset: barOffset
        });
        barOffset = germanPercent;
        this.setProperties("foreign-citizenship", {
            value: this.formatNumber(foreign),
            percentage: this.formatNumber(foreignPercent),
            barOffset: barOffset
        });
    }
    updateSectionWork() {
        const residentsInDestrict = this.valueByPath([
            "residents"
        ]);
        const employed = this.valueByPath([
            "employed_residents"
        ]);
        const employedPercent = employed / residentsInDestrict * 100;
        const employedRate = this.valueByPath([
            "employment_rate"
        ]);
        const unemployed = this.valueByPath([
            "unemployed_residents"
        ]);
        const unemployedPercent = unemployed / residentsInDestrict * 100;
        let barOffset = 0;
        this.setProperties("employed-residents", {
            value: this.formatNumber(employed),
            percentage: this.formatNumber(employedPercent),
            barOffset: barOffset
        });
        this.setProperties("employed-rate", {
            value: this.formatNumber(employedRate)
        });
        barOffset = employedPercent;
        this.setProperties("unemployed-residents", {
            value: this.formatNumber(unemployed),
            percentage: this.formatNumber(unemployedPercent),
            barOffset: barOffset
        });
        const settings = [
            {
                id: "percentage-sgb-iii",
                path: [
                    "unemployment_characteristics",
                    "percentage_sgb_iii"
                ],
                default: 0
            },
            {
                id: "percentage-sgb-ii",
                path: [
                    "unemployment_characteristics",
                    "percentage_sgb_ii"
                ],
                default: 0
            },
            {
                id: "percentage-foreign-citizenship",
                path: [
                    "unemployment_characteristics",
                    "percentage_foreign_citizenship"
                ],
                default: 0
            },
            {
                id: "percentage-female",
                path: [
                    "unemployment_characteristics",
                    "percentage_female"
                ],
                default: 0
            },
            {
                id: "percentage-age-under-25",
                path: [
                    "unemployment_characteristics",
                    "percentage_age_under_25"
                ],
                default: 0
            }
        ];
        this.setPropertyValue(settings);
    }
    updateSectionHousingBenefit() {
        const residentsInDestrict = this.valueByPath([
            "residents"
        ]);
        const housingBenefit = this.valueByPath([
            "housing_benefit"
        ]);
        const percent = housingBenefit / residentsInDestrict * 100;
        this.setProperties("housing-benefit", {
            value: this.formatNumber(housingBenefit)
        });
        this.setProperties("housing-benefit-percent", {
            value: this.formatNumber(percent)
        });
    }
    updateSectionHousingAssistance() {
        const settings = [
            {
                id: "housing-assistance-general-consulting",
                path: [
                    "housing_assistance",
                    "general_consulting"
                ],
                default: 0
            },
            {
                id: "housing-assistance-notices-of-rent-arrears",
                path: [
                    "housing_assistance",
                    "notices_of_rent_arrears"
                ],
                default: 0
            },
            {
                id: "housing-assistance-termination-rent-arrears",
                path: [
                    "housing_assistance",
                    "termination_rent_arrears"
                ],
                default: 0
            },
            {
                id: "housing-assistance-termination-for-conduct",
                path: [
                    "housing_assistance",
                    "termination_for_conduct"
                ],
                default: 0
            },
            {
                id: "housing-assistance-action-for-eviction",
                path: [
                    "housing_assistance",
                    "action_for_eviction"
                ],
                default: 0
            },
            {
                id: "housing-assistance-eviction-notice",
                path: [
                    "housing_assistance",
                    "eviction_notice"
                ],
                default: 0
            },
            {
                id: "housing-assistance-eviction-carried",
                path: [
                    "housing_assistance",
                    "eviction_carried"
                ],
                default: 0
            }
        ];
        const total = this.setPropertyValue(settings);
        this.setProperties("housing-assistance-total", {
            value: this.formatNumber(total)
        });
    }
    /**
   * Get value by path from current model
   */ valueByPath(path) {
        return this.model.districtData.valueByPath(path);
    }
    /**
   * Set the value property of one ore many components.
   */ setPropertyValue(settings) {
        let total = 0;
        settings.forEach((item, i)=>{
            let value = this.valueByPath(item.path);
            if (value === null || value === undefined) value = item.default;
            this.setProperties(item.id, {
                value: this.formatNumber(value)
            });
            total += value;
        });
        return total;
    }
    onDataChanged(data) {
        this.model.setDataObject(data);
        this.model.setDistrictData(this.model.districtId);
        this.sendMessageToComponent("district-select", {
            setByModel: this.model
        });
        this.updateView();
    }
    onDistrictChanged(id) {
        this.model.setDistrictId(id);
        this.model.setDistrictData(id);
        this.sendMessageToComponent("district-select", {
            value: id
        });
        this.sendMessageToComponent("district-map", {
            selectPath: id
        });
        this.updateView();
    }
}


class $997f6da630d07c20$export$2e2bcd8739ae039 {
    constructor(data){
        this.data = data;
    }
    hasAttribute(obj, attributeName) {
        return typeof obj === "object" && obj !== null && attributeName in obj;
    }
    valueByPath(path) {
        let value = this.data;
        for (const key of path)if (this.hasAttribute(value, key)) value = value[key];
        else {
            value = undefined;
            break;
        }
        return value;
    }
    filter(condition) {
        return this.data.filter(condition);
    }
}

class $681c70d080bf9c13$export$2e2bcd8739ae039 {
    /* eslint no-useless-constructor: 0 */ constructor(){}
    getStorage(key) {
        return JSON.parse(localStorage.getItem(key));
    }
    setStorage(key, data) {
        localStorage.setItem(key, JSON.stringify(data));
    }
    clearStorage(key) {
        localStorage.removeItem(key);
    }
}


class $c8af32b1336515cf$export$2e2bcd8739ae039 extends (0, $681c70d080bf9c13$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.dataObject = null;
        this.districtCount = 0;
        this.districtNames = null;
        this.districtData = null;
        this.districtId = null;
    }
    bindDataChanged(callback) {
        this.onDataChanged = callback;
    }
    setDataObject(data) {
        this.dataObject = new (0, $997f6da630d07c20$export$2e2bcd8739ae039)(data);
        this.districtCount = data.length;
        this.districtNames = data.detail.map((item)=>item.district_name);
        this.setStorage("data", data);
    }
    setDistrictId(districtId) {
        this.districtId = districtId;
        this.setStorage("districtId", districtId);
    }
    setDistrictData(districtId) {
        const condition = (district)=>district.district_id === districtId;
        const items = this.dataObject.data.detail.filter(condition);
        if (items.length > 0) {
            this.districtData = new (0, $997f6da630d07c20$export$2e2bcd8739ae039)(items[0]);
            this.setStorage("districtData", items[0]);
        }
    }
    /**
   * Get district name.
   */ districtName(districtId) {
        if (districtId === undefined) districtId = this.districtId;
        return this.districtNames[districtId - 1];
    }
    /**
   * Get number of residents total for a specific year.
   */ residentsTotal(...params) {
        return this.dataObject.data.summary.sum_residents;
    }
    residentsInDistrictsArray(...params) {
        return this.dataObject.data.detail.map((item)=>item.residents);
    }
    birthsTotal(...params) {
        const values = this.birthsInDistrictsArray();
        let sum = 0;
        values.forEach((v)=>{
            sum += v;
        });
        return sum;
    }
    birthsInDistrictsArray(...params) {
        return this.dataObject.data.detail.map((item)=>item.births);
    }
}



class $0ba7ee4f40dd747f$export$2e2bcd8739ae039 extends (0, $5d2cf9394863bd7b$export$2e2bcd8739ae039) {
    constructor(parent, id, setupData){
        super(parent, id, setupData);
        this.setProperties(setupData);
    }
    build() {
        this.e = this.addDomElement("div");
        this.e.style.display = "grid";
    }
}



class $0d26dc9b417fae91$export$2e2bcd8739ae039 extends (0, $5d2cf9394863bd7b$export$2e2bcd8739ae039) {
    constructor(parent, id, setupData){
        super(parent, id, setupData);
        this.html = null;
        this.setProperties(setupData);
    }
    getPropertyNames() {
        const names = [
            "html"
        ];
        return super.getPropertyNames(names);
    }
    propertiesChanged() {
        if (this.e !== null) this.e.innerHTML = this.html;
    }
    build() {
        this.e = this.addDomElement("text");
        this.e.innerHTML = this.html;
    }
    addText(type, text) {
        const types = [
            "h1",
            "h2",
            "h3",
            "h4",
            "p"
        ];
        if (types.includes(type)) this.html = `<${type}>text</${type}>`;
    }
}



class $746c83a62efb7f88$export$2e2bcd8739ae039 extends (0, $5d2cf9394863bd7b$export$2e2bcd8739ae039) {
    constructor(parent, id, setupData){
        super(parent, id, setupData);
        this.filePath = null;
        this.colors = null;
        this.selectedPathIndex = null;
        this.setProperties(setupData);
    }
    getPropertyNames() {
        const names = [
            "filePath",
            "colors"
        ];
        return super.getPropertyNames(names);
    }
    propertiesChanged() {}
    handleMessage(message) {
        if (typeof message === "object") Object.keys(message).forEach((key)=>{
            if (key === "colors") this.setColors(message[key]);
            else if (key === "selectPath") {
                const selectedPath = this.e.getElementById(`path-${message[key]}`);
                const paths = this.e.querySelectorAll("path");
                paths.forEach((path, index)=>{
                    if (path !== selectedPath) path.classList.remove("selected");
                    else path.classList.add("selected");
                });
            }
        });
    }
    setColors(items) {
        if (typeof items === "object") Object.keys(items).forEach((key)=>{
            if (key === "all") {
                // Get all the <path> elements within the SVG
                const paths = this.e.querySelectorAll("path");
                // Loop through the paths and access their "d" attribute
                paths.forEach((path, index)=>{
                    path.style.fill = items[key];
                });
            }
            if (key.startsWith("!")) {
                // Get all the <path> elements within the SVG
                const paths = this.e.querySelectorAll("path");
                const excludePath = this.e.getElementById(key.substring(1));
                // Loop through the paths and access their "d" attribute
                paths.forEach((path, index)=>{
                    if (path !== excludePath) path.style.fill = items[key];
                });
            } else {
                const pathElement = this.e.getElementById(key);
                if (pathElement !== null) pathElement.style.fill = items[key];
            }
        });
    }
    build() {
        // Create an SVG element
        this.e = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        // Set attributes for the SVG element
        this.e.setAttribute("width", "400px");
        this.e.setAttribute("viewBox", "0 0 1200 800");
        this.e.setAttribute("version", "1.1");
        this.e.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        this.e.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
        this.e.setAttribute("xml:space", "preserve");
        this.e.setAttribute("style", "fill-rule:evenodd;clip-rule:evenodd;");
        this.buildPathsFromFile(this.filePath);
        this.addElementClasslist(this.e, this.classList);
        this.parent.e.appendChild(this.e);
    }
    /**
   *  Function to build paths from data in a file.
   */ buildPathsFromFile(filePath) {
        fetch(filePath).then((response)=>response.json()).then((data)=>{
            data.forEach((pathItem)=>{
                const path = document.createElementNS("http://www.w3.org/2000/svg", "path") // TODO: Move to library helper class.
                ;
                path.setAttribute("d", pathItem.data);
                path.setAttribute("id", `path-${pathItem.id}`);
                path.setAttribute("data-id", `${pathItem.id}`);
                path.setAttribute("class", "clickable-path") // TODO: Ability to set classList for items in SVG.
                ;
                if (this.events !== null) this.events.forEach((event)=>{
                    path.addEventListener(event.type, ()=>event.handler(this, pathItem.id));
                });
                // Append the new path to the SVG container
                this.e.appendChild(path);
            });
        }).catch((error)=>{
            console.error("Error fetching data:", error) // TODO: Give a more precise error message
            ;
        });
    }
}




class $e7d9f66af33cc815$export$2e2bcd8739ae039 extends (0, $5d2cf9394863bd7b$export$2e2bcd8739ae039) {
    constructor(parent, id, setupData){
        super(parent, id, setupData);
        this.values = null;
        this.maxValue = "auto";
        this.totalValue = 0;
        this.width = 100;
        this.height = 100;
        this.gap = 4;
        this.chartType = "pie";
        this.setProperties(setupData);
    }
    getPropertyNames() {
        const names = [
            "values",
            "maxValue",
            "width",
            "height",
            "gap",
            "chartType"
        ];
        return super.getPropertyNames(names);
    }
    propertiesChanged() {
        this.totalValue = this.values.reduce((sum, value)=>sum + value, 0);
        if (this.e !== null) {
            this.e.replaceChildren();
            this.buildSvgContent();
        }
    }
    build() {
        const svg = this.e = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("width", this.width);
        svg.setAttribute("height", this.height);
        svg.setAttribute("viewBox", `0 0 ${this.width} ${this.height}`);
        this.addElementClasslist(svg, this.classList);
        this.parent.e.appendChild(svg);
        this.buildSvgContent();
    }
    buildSvgContent() {
        switch(this.chartType){
            case "pie":
                this.buildSvgPieChart();
                break;
            default:
                this.buildSvgBarChart();
        }
    }
    buildSvgPieChart() {
        if (this.values !== null) {
            if (Array.isArray(this.values)) {
                const svg = this.e;
                const centerX = this.width / 2;
                const centerY = this.height / 2;
                const radius = Math.min(centerX, centerY) - 2;
                const innerRadius = 20;
                let startAngle = 0;
                // Create a pie slice for each data point
                this.values.forEach((value, index)=>{
                    const endAngle = startAngle + value / this.totalValue * 360;
                    // Convert angles to radians
                    const startAngleRad = (startAngle - 90) * (Math.PI / 180);
                    const endAngleRad = (endAngle - 90) * (Math.PI / 180);
                    // Calculate the slice's path
                    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
                    const x1 = centerX + radius * Math.cos(startAngleRad);
                    const y1 = centerY + radius * Math.sin(startAngleRad);
                    const x2 = centerX + radius * Math.cos(endAngleRad);
                    const y2 = centerY + radius * Math.sin(endAngleRad);
                    const d = this.svgCreateDonutPath(centerX, centerY, startAngle, endAngle, innerRadius, radius);
                    const largeArcFlag = value / this.totalValue > 0.5 ? 1 : 0;
                    path.setAttribute("d", d);
                    path.setAttribute("class", "xxx");
                    if (index & 0x1) path.setAttribute("fill", "#999");
                    else path.setAttribute("fill", "#ccc");
                    svg.appendChild(path);
                    // Update the startAngle for the next slice
                    startAngle = endAngle;
                });
            }
        }
    }
    /**
   *
   */ buildSvgBarChart() {
        if (this.values !== null) {
            if (Array.isArray(this.values)) {
                const svg = this.e;
                const n = this.values.length;
                const gap = this.gap;
                const w = (this.width - gap * (n - 1)) / n;
                let maxValue = 100;
                if (this.maxValue === "auto") maxValue = Math.max.apply(null, this.values);
                else maxValue = this.maxValue;
                const barsCount = this.values.length;
                let sum = 0;
                for(let i = 0; i < barsCount; i++){
                    const polygon = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
                    svg.appendChild(polygon);
                    const h = this.values[i] / maxValue * this.height;
                    const x = (w + gap) * i;
                    const y = this.height - h;
                    const x1 = (0, $3015b282b063971c$export$2e2bcd8739ae039).numberToString(x);
                    const x2 = (0, $3015b282b063971c$export$2e2bcd8739ae039).numberToString(x + w);
                    const y1 = (0, $3015b282b063971c$export$2e2bcd8739ae039).numberToString(y);
                    const y2 = (0, $3015b282b063971c$export$2e2bcd8739ae039).numberToString(y + h);
                    polygon.setAttribute("class", "xxx");
                    polygon.setAttribute("points", `${x1},${y1} ${x2},${y1} ${x2},${y2} ${x1},${y2}`);
                    polygon.setAttribute("fill", "#0069f6");
                    polygon.setAttribute("stroke", "none");
                    svg.appendChild(polygon);
                    sum += this.values[i];
                }
                {
                    const polygon = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
                    svg.appendChild(polygon);
                    const mean = sum / barsCount;
                    const h = 1;
                    const x = 0;
                    const y = this.height - mean / maxValue * this.height;
                    const x1 = 0;
                    const x2 = (0, $3015b282b063971c$export$2e2bcd8739ae039).numberToString(this.width);
                    const y1 = (0, $3015b282b063971c$export$2e2bcd8739ae039).numberToString(y);
                    const y2 = (0, $3015b282b063971c$export$2e2bcd8739ae039).numberToString(y + 0.5);
                    polygon.setAttribute("points", `${x1},${y1} ${x2},${y1} ${x2},${y2} ${x1},${y2}`);
                    polygon.setAttribute("fill", "#ccc");
                    polygon.setAttribute("stroke", "none");
                    polygon.style.mixBlendMode = "multiply" // Set the blend mode
                    ;
                    svg.appendChild(polygon);
                }
            }
        }
    }
    svgCreateDonutPath(centerX, centerY, startAngle, endAngle, innerRadius, radius) {
        // Convert degrees to radians
        const startAngleRad = (startAngle - 90) * (Math.PI / 180 // Subtract 90 to start from the top
        );
        const endAngleRad = (endAngle - 90) * (Math.PI / 180);
        // Calculate start and end points for the inner circle
        const innerStartX = centerX + innerRadius * Math.cos(startAngleRad);
        const innerStartY = centerY + innerRadius * Math.sin(startAngleRad);
        const innerEndX = centerX + innerRadius * Math.cos(endAngleRad);
        const innerEndY = centerY + innerRadius * Math.sin(endAngleRad);
        // Calculate start and end points for the outer circle
        const outerStartX = centerX + radius * Math.cos(startAngleRad);
        const outerStartY = centerY + radius * Math.sin(startAngleRad);
        const outerEndX = centerX + radius * Math.cos(endAngleRad);
        const outerEndY = centerY + radius * Math.sin(endAngleRad);
        // Determine if the arc is larger than 180 degrees
        const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
        // Construct the SVG path string
        const path = `
      M${innerStartX},${innerStartY}
      L${outerStartX},${outerStartY}
      A${radius},${radius} 0 ${largeArcFlag} 1 ${outerEndX},${outerEndY}
      L${innerEndX},${innerEndY}
      A${innerRadius},${innerRadius} 0 ${largeArcFlag} 0 ${innerStartX},${innerStartY}
      Z
    `;
        return path;
    }
}



class $28496fd5ebff33ae$export$2e2bcd8739ae039 extends (0, $5d2cf9394863bd7b$export$2e2bcd8739ae039) {
    constructor(parent, id, setupData){
        super(parent, id, setupData);
        this.label = "Button";
        this.setProperties(setupData);
    }
    getPropertyNames() {
        const names = [
            "label"
        ];
        return super.getPropertyNames(names);
    }
    propertiesChanged() {
        if (this.e !== null) this.e.innerText = this.label;
    }
    build() {
        this.e = this.addDomElement("button");
        this.e.innerText = this.label;
    }
}



class $bde09bd82cf08d56$export$2e2bcd8739ae039 extends (0, $5d2cf9394863bd7b$export$2e2bcd8739ae039) {
    constructor(parent, id, setupData){
        super(parent, id, setupData);
        this.setProperties(setupData);
    }
    getPropertyNames() {
        const names = [];
        return super.getPropertyNames(names);
    }
    build() {
        this.e = this.addDomElement("select");
        if (this.events !== null) this.events.forEach((item)=>{
            this.e.addEventListener(item.event, ()=>item.handler(this));
        });
    }
    setByModel(model) {
        model.districtNames.forEach((name, i)=>{
            const optionElement = this.createDomElement("option");
            optionElement.value = i + 1;
            optionElement.textContent = name;
            if (optionElement.value === model.districtId) optionElement.selected = true;
            this.e.appendChild(optionElement);
        });
    }
    handleMessage(message) {
        if (typeof message === "object") Object.keys(message).forEach((key)=>{
            if (key === "value") this.e.value = message[key];
            else if (key === "setByModel") this.setByModel(message[key]);
        });
    }
}



class $c35d15b39eca6005$export$2e2bcd8739ae039 extends (0, $5d2cf9394863bd7b$export$2e2bcd8739ae039) {
    /**
     * Create a NumView.
     *
     * @param {Component} parent - The parent component.
     * @param {String} id - The id of the new Component.
     * @param {any} setupData - Optional set up data.
     */ constructor(parent, id, setupData){
        super(parent, id, setupData);
        this.label = "Label";
        this.value = 0;
        this.preText = null // Text before the value, i. e. a currency.
        ;
        this.postText = null // Text after the value, i. e. a unit.
        ;
        this.setProperties(setupData);
    }
    /**
     *  Build the DOM Elements for HTML rendering og the component.
     *
     *  This method mus be overridden in derived classes.
     *
     *  Styling:
     *  One solution is to assign classes to the emelemts.
     */ build() {
        this.e = this.addDomElement("div");
        let a = this.e.appendChild(this.createDomElement("div"));
        a.style.textAlign = "center";
        a.innerText = this.label;
        a.className = "label";
        a = this.e.appendChild(this.createDomElement("div"));
        a.style.textAlign = "center";
        a.innerText = this.value;
        a.className = "value";
    }
    getPropertyNames() {
        const names = [
            "label",
            "value",
            "preText",
            "postText"
        ];
        return super.getPropertyNames(names);
    }
    propertiesChanged() {
        if (this.e !== null) {
            let text = this.value;
            if (this.postText !== null) text += this.postText;
            this.e.children.item(1).innerText = text;
        }
    }
    gradient() {
        const p = parseFloat(this.percentage);
        const color1 = this.barColor1;
        const color2 = this.barColor2;
        const spot1 = `${this.barOffset}%`;
        const spot2 = `${this.barOffset + 0.1}%`;
        const spot3 = `${this.barOffset + p - 0.1}%`;
        const spot4 = `${this.barOffset + p}%`;
        return `linear-gradient(90deg, ${color1} 0%, ${color1} ${spot1}, ${color2} ${spot2}, ${color2} ${spot3}, ${color1} ${spot4})`;
    }
}




class $f9ee10b66d77ab93$export$2e2bcd8739ae039 extends (0, $5d2cf9394863bd7b$export$2e2bcd8739ae039) {
    /**
     * Create a NumPercentView.
     *
     * @param {Component} parent - The parent component.
     * @param {String} id - The id of the new Component.
     * @param {any} setupData - Optional set up data.
     */ constructor(parent, id, setupData){
        super(parent, id, setupData);
        this.label = "Label";
        this.value = 100;
        this.percentage = 10;
        this.barOffset = 0;
        this.barColor1 = "#999";
        this.barColor2 = "#333";
        this.setProperties(setupData);
    }
    /**
     *  Build the DOM Elements for HTML rendering og the component.
     *
     *  This method mus be overridden in derived classes.
     *
     *  Styling:
     *  One solution is to assign classes to the emelemts.
     */ build() {
        this.e = this.addDomElement("div");
        let a = this.e.appendChild(this.createDomElement("div"));
        a.innerText = this.label;
        a.classList = "label";
        a = this.e.appendChild(this.createDomElement("div"));
        a.innerText = this.value;
        a.classList = "value";
        const gradient = this.gradient();
        a = this.e.appendChild(this.createDomElement("div"));
        a.style.background = gradient;
        a.classList = "bar";
        a = this.e.appendChild(this.createDomElement("div"));
        a.innerText = `${this.percentage} %`;
        a.classList = "percentage";
    }
    getPropertyNames() {
        const names = [
            "label",
            "value",
            "percentage",
            "barOffset",
            "barColor1",
            "barColor2"
        ];
        return super.getPropertyNames(names);
    }
    propertiesChanged() {
        if (this.e !== null) {
            this.e.children.item(1).innerText = this.value;
            this.e.children.item(2).style.background = this.gradient();
            this.e.children.item(3).innerText = `${this.percentage} %`;
        }
    }
    gradient() {
        const p = parseFloat(this.percentage);
        const color1 = this.barColor1;
        const color2 = this.barColor2;
        const spot1 = (0, $3015b282b063971c$export$2e2bcd8739ae039).numberToString(this.barOffset);
        const spot2 = (0, $3015b282b063971c$export$2e2bcd8739ae039).numberToString(this.barOffset + 0.1);
        const spot3 = (0, $3015b282b063971c$export$2e2bcd8739ae039).numberToString(this.barOffset + p - 0.1);
        const spot4 = (0, $3015b282b063971c$export$2e2bcd8739ae039).numberToString(this.barOffset + p);
        return `linear-gradient(90deg, ${color1} 0%, ${color1} ${spot1}%, ${color2} ${spot2}%, ${color2} ${spot3}%, ${color1} ${spot4}%)`;
    }
}




// Create model
const $5fbffa87c50562b9$var$model = new (0, $c8af32b1336515cf$export$2e2bcd8739ae039)();
// Create view
const $5fbffa87c50562b9$var$view = new (0, $66a0619dcedb518c$export$2e2bcd8739ae039)();
// Create app
const $5fbffa87c50562b9$var$app = new (0, $3015b282b063971c$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$model, $5fbffa87c50562b9$var$view);
$5fbffa87c50562b9$var$app.configurate({
    locale: "de-DE"
});
// Create views and components
{
    const section = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "section-1", {
        classList: "section apple padding-10"
    });
    new (0, $28496fd5ebff33ae$export$2e2bcd8739ae039)(section, "button-1", {
        label: "Hide",
        events: [
            {
                type: "click",
                handler: $5fbffa87c50562b9$var$hideSectionsHandler
            }
        ]
    });
    new (0, $28496fd5ebff33ae$export$2e2bcd8739ae039)(section, "button-2", {
        label: "Show",
        events: [
            {
                type: "click",
                handler: $5fbffa87c50562b9$var$showSectionsHandler
            }
        ]
    });
    new (0, $28496fd5ebff33ae$export$2e2bcd8739ae039)(section, "button-reset", {
        label: "Reset",
        events: [
            {
                type: "click",
                handler: $5fbffa87c50562b9$var$resetHandler
            }
        ]
    });
    new (0, $bde09bd82cf08d56$export$2e2bcd8739ae039)(section, "district-select", {
        classList: "district-select",
        events: [
            {
                type: "change",
                handler: $5fbffa87c50562b9$var$districtSelectHandler
            }
        ]
    });
    new (0, $0d26dc9b417fae91$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "text-distict-details", {
        classList: "supertext",
        html: "<h1>District</h>"
    });
    new (0, $746c83a62efb7f88$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "district-map", {
        filePath: "./flensburg-district-paths.js",
        eventMode: "custom",
        events: [
            {
                type: "click",
                handler: $5fbffa87c50562b9$var$mapClickHandler
            }
        ]
    });
}// Section Einwohner*innen im Stadtteil
{
    new (0, $0d26dc9b417fae91$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "text-1", {
        classList: "supertext",
        html: "<h1>Einwohner*innen im Stadtteil</h1>"
    });
    const section = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "section-2", {
        classList: "section banana padding-10"
    });
    const subView1 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(section, "subview-2-1", {
        classList: "section ibm"
    });
    const subView1_1 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(subView1, "subview-2-1-1", {
        classList: "section lenovo"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(subView1_1, "residents-in-destrict", {
        classList: "num-percent",
        label: "Anzahl"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(subView1_1, "residents-percent-in-destrict", {
        classList: "num-percent",
        label: "Anteil Stadt",
        postText: " %"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(subView1_1, "residents-total", {
        classList: "num-percent",
        label: "Stadt gesamt"
    });
    const subView1_2 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(subView1, "subview-2-1", {
        classList: "section lenovo"
    });
    for(let i = 1; i <= 8; i++){
        const labels = [
            "0 - 18",
            "18 - 30",
            "30 - 45",
            "45 - 65",
            "65 - 80",
            "80+",
            "0 - 8",
            "60+"
        ];
        new (0, $f9ee10b66d77ab93$export$2e2bcd8739ae039)(subView1_2, `age-view-${i}`, {
            classList: "num-percent",
            label: labels[i - 1],
            barColor1: "#d1e4fd",
            barColor2: "#0069f6"
        });
    }
    const subView2 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(section, "subview-2-2", {
        classList: "section sgi"
    });
    new (0, $e7d9f66af33cc815$export$2e2bcd8739ae039)(subView2, "svg", {
        classList: "custom-demo-component",
        width: 200,
        height: 100,
        chartType: "bar",
        maxValue: "auto",
        values: [
            10,
            20,
            30,
            40,
            50,
            60,
            70,
            80,
            90,
            100
        ]
    });
}// Section Schule/Arbeit/Rente
{
    new (0, $0d26dc9b417fae91$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "text-3", {
        classList: "supertext",
        html: "<h1>Schule/Arbeit/Rente</h>"
    });
    const section = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "section-3", {
        classList: "section banana padding-10"
    });
    const subView1 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(section, "subview-2-1", {
        classList: "section lenovo"
    });
    new (0, $f9ee10b66d77ab93$export$2e2bcd8739ae039)(subView1, "residents-0-18", {
        classList: "num-percent",
        label: "0 - 18",
        barColor1: "#d1e4fd",
        barColor2: "#0069f6"
    });
    new (0, $f9ee10b66d77ab93$export$2e2bcd8739ae039)(subView1, "residents-18-65", {
        classList: "num-percent",
        label: "18 - 65",
        barColor1: "#d1e4fd",
        barColor2: "#0069f6"
    });
    new (0, $f9ee10b66d77ab93$export$2e2bcd8739ae039)(subView1, "residents-65-above", {
        classList: "num-percent",
        label: "65+",
        barColor1: "#d1e4fd",
        barColor2: "#0069f6"
    });
    const subView2 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(section, "subview-2-1", {
        classList: "section sgi"
    });
    new (0, $e7d9f66af33cc815$export$2e2bcd8739ae039)(subView2, "svg2", {
        classList: "custom-demo-component",
        width: 200,
        height: 100,
        values: [
            10,
            20,
            30,
            40,
            50,
            60,
            70,
            80,
            90,
            100,
            10,
            1000,
            30
        ]
    });
}// Section Geburten
{
    new (0, $0d26dc9b417fae91$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "text-4", {
        classList: "supertext",
        html: "<h1>Geburten</h>"
    });
    const section = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "section-4", {
        classList: "section banana padding-10"
    });
    const subView1 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(section, "subview-2-1", {
        classList: "section lenovo"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(subView1, "births", {
        classList: "num-percent",
        label: "Anzahl"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(subView1, "births-percent", {
        classList: "num-percent",
        label: "Anteil Stadt",
        postText: " %"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(subView1, "births-total", {
        classList: "num-percent",
        label: "Stadt gesamt"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(subView1, "births-rate", {
        classList: "num-percent",
        label: "Quote"
    });
    const subView2 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(section, "subview-2-2", {
        classList: "section sgi"
    });
    new (0, $e7d9f66af33cc815$export$2e2bcd8739ae039)(subView2, "births-chart", {
        classList: "custom-demo-component",
        width: 200,
        height: 100,
        maxValue: "auto",
        values: [
            10,
            20,
            30,
            40,
            50,
            60,
            70,
            80,
            90,
            100
        ]
    });
}// Section Altenquotient
{
    new (0, $0d26dc9b417fae91$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "text-4", {
        classList: "supertext",
        html: "<h1>Altenquotient</h>"
    });
    const section = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "section-5", {
        classList: "section banana padding-10"
    });
    const subView1 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(section, "subview", {
        classList: "section lenovo"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(subView1, "age-ratio", {
        classList: "num-percent",
        label: "Quotient"
    });
    const subView2 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(section, "subview-2-2", {
        classList: "section sgi"
    });
}// Section Migrationshintergrund
{
    new (0, $0d26dc9b417fae91$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "text-5", {
        classList: "supertext",
        html: "<h1>Migrationshintergrund</h>"
    });
    const section = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "section-6", {
        classList: "section banana padding-10"
    });
    const subView1 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(section, "subview", {
        classList: "section lenovo"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(subView1, "residents-migration-background", {
        classList: "num-percent",
        label: "Gesamt"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(subView1, "residents-migration-background-percent", {
        classList: "num-percent",
        label: "Anteil",
        postText: " %"
    });
    new (0, $f9ee10b66d77ab93$export$2e2bcd8739ae039)(subView1, "german-citizenship", {
        classList: "num-percent",
        label: "deutsch",
        barColor1: "#d1e4fd",
        barColor2: "#0069f6"
    });
    new (0, $f9ee10b66d77ab93$export$2e2bcd8739ae039)(subView1, "foreign-citizenship", {
        classList: "num-percent",
        label: "ausl\xe4ndisch",
        barColor1: "#d1e4fd",
        barColor2: "#0069f6"
    });
    const subView2 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(section, "subview-2-2", {
        classList: "section sgi"
    });
}// Section Arbeitsmarkt und Beschäftigte
{
    new (0, $0d26dc9b417fae91$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "text-5", {
        classList: "supertext",
        html: "<h1>Arbeitsmarkt und Besch\xe4ftigte</h>"
    });
    const section = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "section-7", {
        classList: "section banana padding-10"
    });
    const subView1 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(section, "subview", {
        classList: "section ibm"
    });
    const row1 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(subView1, "subview-2-1-1", {
        classList: "section lenovo"
    });
    new (0, $f9ee10b66d77ab93$export$2e2bcd8739ae039)(row1, "employed-residents", {
        classList: "num-percent",
        label: "Besch\xe4ftige",
        barColor1: "#d1e4fd",
        barColor2: "#0069f6"
    });
    new (0, $f9ee10b66d77ab93$export$2e2bcd8739ae039)(row1, "unemployed-residents", {
        classList: "num-percent",
        label: "Arbeitslose",
        barColor1: "#d1e4fd",
        barColor2: "#0069f6"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(row1, "employed-rate", {
        classList: "num-percent",
        label: "BQ",
        postText: " %"
    });
    const row2 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(subView1, "subview-2-2", {
        classList: "section lenovo"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(row2, "percentage-sgb-iii", {
        classList: "num-percent",
        label: "nur SGB III",
        postText: " %"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(row2, "percentage-sgb-ii", {
        classList: "num-percent",
        label: "nur SGB II",
        postText: " %"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(row2, "percentage-foreign-citizenship", {
        classList: "num-percent",
        label: "ausl\xe4ndisch",
        postText: " %"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(row2, "percentage-female", {
        classList: "num-percent",
        label: "Frauen",
        postText: " %"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(row2, "percentage-age-under-25", {
        classList: "num-percent",
        label: "j\xfcnger als 25",
        postText: " %"
    });
    const subView2 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(section, "subview-2-2", {
        classList: "section sgi"
    });
}// Section Wohngeldempfänger*innen
{
    new (0, $0d26dc9b417fae91$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "text-5", {
        classList: "supertext",
        html: "<h1>Wohngeldempf\xe4nger*innen</h1>"
    });
    const section = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "section-8", {
        classList: "section banana padding-10"
    });
    const subView1 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(section, "subview", {
        classList: "section ibm"
    });
    const row1 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(subView1, "subview-2-1-1", {
        classList: "section lenovo"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(row1, "housing-benefit", {
        classList: "num-percent",
        label: "Anzahl"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(row1, "housing-benefit-percent", {
        classList: "num-percent",
        label: "Anteil",
        postText: " %"
    });
    const subView2 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(section, "subview-2-2", {
        classList: "section sgi"
    });
}// Section Wohnungshilfefälle
{
    new (0, $0d26dc9b417fae91$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "text-5", {
        classList: "supertext",
        html: "<h1>Wohnungshilfef\xe4lle</h1>"
    });
    const section = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)($5fbffa87c50562b9$var$view, "section-9", {
        classList: "section banana padding-10"
    });
    const subView1 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(section, "subview", {
        classList: "section ibm"
    });
    const row1 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(subView1, "subview-2-1-1", {
        classList: "section lenovo"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(row1, "housing-assistance-total", {
        classList: "num-percent",
        label: "Gesamt"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(row1, "housing-assistance-general-consulting", {
        classList: "num-percent",
        label: "Allgemeine Beratung"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(row1, "housing-assistance-notices-of-rent-arrears", {
        classList: "num-percent",
        label: "Mitteilungen \xfcber Mietr\xfcckst\xe4nde"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(row1, "housing-assistance-termination-rent-arrears", {
        classList: "num-percent",
        label: "K\xfcndigung wg. Mietr\xfcckst\xe4nden"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(row1, "housing-assistance-termination-for-conduct", {
        classList: "num-percent",
        label: "K\xfcndigung wg. Verhalten"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(row1, "housing-assistance-action-for-eviction", {
        classList: "num-percent",
        label: "R\xe4umungsklagen"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(row1, "housing-assistance-eviction-notice", {
        classList: "num-percent",
        label: "R\xe4umnungsank\xfcndigungen"
    });
    new (0, $c35d15b39eca6005$export$2e2bcd8739ae039)(row1, "housing-assistance-eviction-carried", {
        classList: "num-percent",
        label: "Tats\xe4chlich durchgef\xfchrte R\xe4umungen"
    });
    const subView2 = new (0, $0ba7ee4f40dd747f$export$2e2bcd8739ae039)(section, "subview-2-2", {
        classList: "section sgi"
    });
}$5fbffa87c50562b9$var$app.buildView("#root");
// Init app, must be called after configurate and buildView
// TODO: Compare hash from local storage. If not equal force clean.
$5fbffa87c50562b9$var$app.initApp("./details.json", 1);
// Handlers
// TODO: Move handlers to a handler class
function $5fbffa87c50562b9$var$districtSelectHandler(component) {
    $5fbffa87c50562b9$var$app.onDistrictChanged(component.e.value);
}
function $5fbffa87c50562b9$var$resetHandler(component) {
    localStorage.clear();
    $5fbffa87c50562b9$var$app.onDistrictChanged(1);
}
function $5fbffa87c50562b9$var$mapClickHandler(component, disrictId) {
    $5fbffa87c50562b9$var$app.onDistrictChanged(disrictId);
}
function $5fbffa87c50562b9$var$hideSectionsHandler(component) {
    for(let i = 2; i <= 9; i++){
        const section = $5fbffa87c50562b9$var$app.getComponentById(`section-${i}`);
        if (section !== undefined) section.e.style.display = "none";
    }
}
function $5fbffa87c50562b9$var$showSectionsHandler(component) {
    for(let i = 2; i <= 9; i++){
        const section = $5fbffa87c50562b9$var$app.getComponentById(`section-${i}`);
        if (section !== undefined) section.e.style.display = "grid";
    }
}

})();
//# sourceMappingURL=index.812d7db4.js.map
